import classNames from 'classnames'
import { MyImage } from '~/components/ui/MyImage'
import { IMessage } from '../deepseek/atom'
import { Warning } from 'wujieai-react-icon'
import { ChatRole } from '~/graphqls/customType'
import { ChatMessageStatusEnum } from '~/graphqls/types'
import { previewImageAtom } from './atom'
import { useAtom } from 'jotai'
import { to800Image } from '~/utils'

export default function Message({ msg }: { msg: IMessage }) {
  return (
    <div
      className={classNames('py-2 w-max max-w-[382px]', {
        'ml-auto w-max': msg.role === ChatRole.USER,
      })}
    >
      {msg.role === ChatRole.ASSISTANT ? (
        <AssistantMessage msg={msg} />
      ) : (
        <UserMessage msg={msg} />
      )}
    </div>
  )
}

function AssistantMessage({ msg }: { msg: IMessage }) {
  const [, setPreviewImage] = useAtom(previewImageAtom)

  if (msg.status === ChatMessageStatusEnum.ERROR) {
    return (
      <div className="p-2 bg-neutral-200 rounded-lg text-sm flex items-center gap-1">
        <Warning size={16} className="text-error" />
        <div>服务器繁忙</div>
      </div>
    )
  }

  if (msg.status === ChatMessageStatusEnum.INIT) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 w-[382px] h-[382px] bg-neutral-200 text-neutral-500 rounded-lg">
        <MyImage
          src={'/images/deepseek/loading.png'}
          className="w-[14px] h-[14px] leading-none block animate-spin origin-center"
        />
        <div>生成中</div>
      </div>
    )
  }

  if (msg.status === ChatMessageStatusEnum.CANCEL) {
    return (
      <div className="p-2 bg-neutral-200 rounded-lg text-sm flex items-center gap-1">
        已停止创建图片
      </div>
    )
  }

  return (
    <>
      <div
        className="bg-neutral-200 space-y-1 rounded-lg overflow-hidden"
        onClick={() => setPreviewImage(msg.image)}
      >
        <MyImage
          src={msg.image}
          dark
          className="w-[382px] h-[382px]"
          tag="v800"
        />
      </div>

      <div className="flex gap-1 items-center text-xs text-neutral-500 mt-1">
        <div>内容由AI生成</div>
      </div>
    </>
  )
}

function UserMessage({ msg }: { msg: IMessage }) {
  const [, setPreviewImage] = useAtom(previewImageAtom)
  return (
    <div>
      {!!msg.referImages?.length && (
        <div className="flex flex-wrap items-center gap-1 mb-4 justify-end">
          {msg.referImages.map((it, index) => {
            return (
              <MyImage
                onClick={() => setPreviewImage(to800Image(it))}
                key={index}
                src={it}
                dark
                className="w-[73px] h-[73px] rounded leading-none block flex-shrink-0"
                tag="v800"
              />
            )
          })}
        </div>
      )}
      <div className="px-4 py-2 bg-primary text-white rounded-lg text-sm whitespace-pre-wrap break-words max-w-[382px] selection:bg-[#4A3195] w-max ml-auto">
        {msg.content}
      </div>
    </div>
  )
}
